import * as React from 'react';
import RecentlyViewedListings, { IProps as RecentlyViewedListingsProps } from '@reverbdotcom/commons/dist/cms/components/recently_viewed_listings';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { experiments } from './shared/constants';
import { VIEW } from '@reverbdotcom/commons/dist/tracker';
import { MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_types';
import track from 'react-tracking';
import bind from '@reverbdotcom/commons/dist/bind';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';

interface IProps extends RecentlyViewedListingsProps, IUserContext {}
interface IState {
  eligible: boolean;
}

const COMPONENT_NAME = 'RecentlyViewedListingsWrapper';

export class RecentlyViewedListingsWrapper extends React.Component<IProps, IState> {
  state = { eligible: false };

  componentDidUpdate(_, prevState) {
    const isEligible = !prevState.eligible && this.state.eligible;
    if (isEligible) {
      this.props.tracking.trackEvent({
        eventType: VIEW,
        mParticleView: {
          componentName: COMPONENT_NAME,
          eventName: MParticleEventName.ComponentView,
          experiments: formatExperimentsForEventAttributes(this.props.user, [
            experiments.RECENTLY_VIEWED_ROWS,
          ]),
        },
      });
    }
  }

  @bind
  setEligible() {
    // Bail early if we're already eligible
    if (this.state.eligible) { return; }

    this.setState({ eligible: true });
  }
  render() {
    const component = <RecentlyViewedListings {...this.props} onVisible={this.setEligible} />;

    const optedIn = isExperimentEnabled(this.props.user, experiments.RECENTLY_VIEWED_ROWS);

    // NOTE: This is a bit hackish. :)
    // The component must exist inside the DOM to calculate the user's eligibility
    // for tracking purposes (regardless of whether or not they're in the experiment).
    // Though if they're not in the experiment, hide it!
    const css = optedIn ? {} : { style: { display: 'none' } };

    return (
      <span {...css}>
        {component}
      </span>
    );
  }
}

export default track({ componentName: COMPONENT_NAME })(withUserContext(RecentlyViewedListingsWrapper));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/recently_viewed_listings_wrapper.tsx